import React from 'react'

const Space = () => {
  return (
    <div className=' p-12 md:p-12 w-full bg-[#0a192f]' ></div>
  )
}

export default Space